<script lang="ts">

    import {
        addDays,
        availabilityForDate,
        dateOnLhsOfDisplay,
        SlotOption
    } from "./dateOptions";
    import dayjs from "dayjs";
    import {dates} from "@docsndata/lang-util";
    import {createEventDispatcher} from 'svelte'
    import {availableTimeSlotsByDate, pricedServicesByDate} from "./state/appState";

    export let dayIndex: number

    function niceDate(date: Date) {
        return dayjs(addDays(date, dayIndex)).format('ddd MMMM D')
    }

    const dispatch = createEventDispatcher()

    function optionChosen(option: SlotOption) {
        dispatch("chosenOption", {dateKey, option, productAvailability: dayAvailability})
    }

    $: dateKey = dates.toIso8601DateOnlyString(addDays($dateOnLhsOfDisplay, dayIndex))
    $: dayAvailability = availabilityForDate(dateKey, $availableTimeSlotsByDate, $pricedServicesByDate)
</script>

{#if dayAvailability}
    <div class="day border border-2 rounded mx-1 text-center my-1">
        <div class="day-title bg-light rounded py-1">
            <div><strong>{niceDate($dateOnLhsOfDisplay)}</strong></div>
            <div class="mt-2">{dayAvailability.label}</div>
        </div>
        <div class="day-content mt-2">
            {#each dayAvailability.options as avail}
                <div class="mb-3"><a class="timeslot" href="#!"
                                     on:click|preventDefault={() => optionChosen(avail)}>{avail.label}</a></div>
            {/each}
        </div>
    </div>
{:else}
    <div class="day border border-2 rounded mx-1 text-center my-1 bg-light">
        <div class="day-title bg-light rounded py-1">
            <div><strong>{niceDate($dateOnLhsOfDisplay)}</strong></div>
        </div>
        <div class="day-content mt-2">
            No availability
        </div>
    </div>
{/if}
